"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUCCESS = exports.PROGRESS = exports.ERROR = exports.REMOVE_FILE = exports.ADD_FILES = void 0;
const ADD_FILES = 'add_files';
exports.ADD_FILES = ADD_FILES;
const REMOVE_FILE = 'remove_file';
exports.REMOVE_FILE = REMOVE_FILE;
const ERROR = 'error';
exports.ERROR = ERROR;
const PROGRESS = 'progress';
exports.PROGRESS = PROGRESS;
const SUCCESS = 'success';
exports.SUCCESS = SUCCESS;
//# sourceMappingURL=actions.js.map